var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.707 3.293a1 1 0 00-1.414 1.414l7.792 7.793-7.378 7.379a1 1 0 101.414 1.414l7.379-7.379 7.056 7.057a1 1 0 001.415-1.415L13.914 12.5l7.47-7.47a1 1 0 00-1.414-1.415l-7.47 7.47-7.793-7.792z",
    fill: "#fff"
  })));
}
export default SvgClose;